import { render, staticRenderFns } from "./ApprovedQuotes.vue?vue&type=template&id=60f9a6cf&"
import script from "./ApprovedQuotes.vue?vue&type=script&lang=js&"
export * from "./ApprovedQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports